import { InfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

type GetStudentCampaignsQuery = {
  code: string
}

type GetStudentCampaigns = InfraResponse<{ applied: boolean }>

export const fetchGetStudentCampaigns = defineFetcher(
  (query: GetStudentCampaignsQuery): Promise<GetStudentCampaigns> => {
    return GET("/student/campaigns", query)
  }
)
